import { useEffect } from "react";

export const useLogValue = (value: any) => {
  useEffect(() => console.log(JSON.stringify(value, null, 2)), [JSON.stringify(value, null, 2)]);
};
